import { styled } from '@mui/material';
import { Flex } from '../../base/Flex';
import { colorPalettes } from '../../../context/theme';

export const StyledTopbar = styled(Flex)(
  {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5385rem',
  },
  ({ theme, sticky, top = 0 }) => ({
    backgroundColor:
      colorPalettes[theme.palette.mode].background.backgroundElements,
    color: colorPalettes[theme.palette.mode].text.primary,
    position: sticky ? 'sticky' : 'static',
    top: sticky ? top : 'auto',
    zIndex: theme.zIndex.appBar,
  }),
);

export const StyledTopbarAvatar = styled.div`
  display: flex;
  align-items: center;

  .topbar-lifebuoy {
    right: 1.1538rem;
    position: relative;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
  }

  .topbar-avatar {
    vertical-align: middle;
  }
`;

export const StyledTopbarContainer = styled(Flex)`
  align-items: center;
  flex: auto;
  height: 3.3rem;
  margin: 0 7.6923rem;
  max-height: 3.3rem;
`;
